import { render } from "./groupSetAdd.vue?vue&type=template&id=4c38f16a&scoped=true"
import script from "./groupSetAdd.vue?vue&type=script&lang=js"
export * from "./groupSetAdd.vue?vue&type=script&lang=js"

import "./groupSetAdd.vue?vue&type=style&index=0&id=4c38f16a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c38f16a"]])

export default __exports__